import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserContext from '../../pages/layout/UserContext';
import checkPermission from './Util';

class Authorized extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { children } = this.props;
    const { asset, operation } = this.props;
    return (
      <UserContext.Consumer>
        {value => {
          return value && checkPermission(value, asset, operation) && children;
        }}
      </UserContext.Consumer>
    );
  }
}

Authorized.propTypes = {
  children: PropTypes.node,
  asset: PropTypes.string,
  operation: PropTypes.string,
};

export default Authorized;
